/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_ARCHIVOADJUNTO_CASO (state, item) {
    state.archivos_adjuntos_caso.unshift(item)
  },
  SET_ARCHIVOADJUNTO_CASO (state, archivos_adjuntos_caso) {
    state.archivos_adjuntos_caso = archivos_adjuntos_caso
    state.meta.push(archivos_adjuntos_caso.meta)
  },
  UPDATE_ARCHIVOADJUNTO_CASO (state, archivo_adjunto_caso) {
    const productIndex = state.archivos_adjuntos_caso.findIndex((p) => p.id === archivo_adjunto_caso.id)
    Object.assign(state.archivos_adjuntos_caso[productIndex], archivo_adjunto_caso)
  },
  REMOVE_ARCHIVOADJUNTO_CASO (state, itemId) {
    const ItemIndex = state.archivos_adjuntos_caso.findIndex((p) => p.id === itemId)
    state.archivos_adjuntos_caso.splice(ItemIndex, 1)
  }
}
